import * as appDialogConstant from '../constants/appDialog';
import * as organizationConstant from '../constants/organizations';

export const ORGANIZATION_USER_ACTIONS = {
    'Assign projects': appDialogConstant.ADD_USERS_TO_BUCKETS,
    'Change role': appDialogConstant.CHANGE_ROLE_IN_ORGANIZATION,
    'Remove user': appDialogConstant.REMOVE_USER_FROM_ORGANIZATION,
};

export const BUCKET_USER_ACTIONS = {
    'Change role': appDialogConstant.CHANGE_ROLE_IN_BUCKET,
    'Remove user': appDialogConstant.REMOVE_USER_FROM_BUCKET,
};

// invited member actions
export const INVITATION_USER_ACTIONS = {
    'Resend invitation':
        organizationConstant.RESEND_ORGANIZATION_MEMBER_INVITATIONS_REQUEST,
    'Revoke invitation':
        organizationConstant.REVOKE_ORGANIZATION_MEMBER_INVITATIONS_REQUEST,
};



// WEBPACK FOOTER //
// ./src/enums/UserActions.js